import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { AppState } from '~/reducers';
import { getMowerOperationSuccessUpdate } from '~/domain/roboticmower-details/utils';
import { MowerSettingsUpdateSuccessNotification } from './MowerSettingsUpdateSuccessNotification';

export const MowerSettingsOperationResultIndication = () => {
  const allOperations = useSelector((state: AppState) => state.assetHfsOperations.operations);
  const operations = useMemo(
    () => allOperations.filter((operation) => !operation.resultNotificationSent),
    [allOperations]
  );
  const schedule = useSelector((state: AppState) => state.assetHfsOperations.mowerSchedule);
  const cuttingHeight = useSelector(
    (state: AppState) => state.assetHfsOperations.mowerCuttingHeight
  );
  const successUpdates = useMemo(
    () =>
      operations
        .map((operation) => getMowerOperationSuccessUpdate(operation, cuttingHeight, schedule))
        .filter((update) => update !== undefined),
    [operations, cuttingHeight, schedule]
  );

  return (
    <>
      {successUpdates.map((update) => (
        <MowerSettingsUpdateSuccessNotification key={update.operationId} update={update} />
      ))}
    </>
  );
};

export default MowerSettingsOperationResultIndication;
